import React from "react";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import DashboardBar from "../components/DashboardBar/DashboardBar";
import DashboardSidebar from "../components/DashboardBar/DashboardSidebar";
import { useUserData } from "../context/UserDataFetcher";

type DashboardLayoutProps = {
  children?: React.ReactNode;
  onNavigate?: (route: string) => void;
};

/**
 * Layout with DashboardBar at the top, a non-collapsable sidebar that takes 20% width,
 * and a main content area that takes the remaining 80%.
 */
const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children, onNavigate }) => {
  const userData = useUserData();
  const showDriverDesktopNotice = userData?.role === "driver";
  return (
    <>
      <DashboardBar onNavigate={onNavigate} />
      <Box sx={(theme) => ({ display: "flex", height: "calc(100vh - 5rem)", backgroundColor: theme.palette.background.default })}>
        {/* Sidebar: 20% width */}
        <Box sx={{ width: "20%", minWidth: 200 }}>
          <DashboardSidebar onNavigate={onNavigate} width="100%" />
        </Box>

        {/* Main content: 80% width */}
        <Box
          component="main"
          sx={{
            width: "80%",
            p: 3,
            overflowY: "auto",
          }}
        >
          {showDriverDesktopNotice && (
            <Alert severity="info" sx={{ mb: 2 }}>
              Driver accounts are read-only on desktop. Please use the Cabinet Scanner mobile app to scan deliveries or capture signatures while reviewing your shipments here.
            </Alert>
          )}
          {children}
        </Box>
      </Box>
    </>
  );
};

export default DashboardLayout;
